import{getDefaultExportFromCjs as o}from"./_commonjsHelpers.mjs";import{__require as r}from"../us_autocomplete_pro/Lookup.mjs";var m=o(r());export{m as default};
